// import { Link } from 'react-router-dom';

const AllofferCard = ({ data }) => {
  return (
    <>
      <div className="all-offers-top-img-grid">
        {/* <div className="two-img-col">
                    <img className="img_1" src={data?.img1} alt="Cyan" />
                    <img className="img_2" src={data?.img2} alt="Cyan" />
                </div> */}
        {/* <div className="one-img-col"> */}
        <img src={data?.thumbnail} alt={data?.tittle?.slice(0, 12)} />
        {/* </div> */}
      </div>
      <h4 className="pt-2  m-0 text-center px-md-2 mx-auto">
        {data?.tittle?.slice(0, 50)}
      </h4>
      <div className="w-75 mx-auto">
        <hr className="my-1" />
      </div>
      <div className="w-100 pb-1 text-center mx-auto  px-3 text-sec fw-bold">
        <h6 className="d-inline px-1">( {data?.period})</h6>{" "}
        <svg
          className="mx-2"
          width="22"
          height="16"
          viewBox="0 0 22 16"
          fill="none"
        >
          <path
            d="M10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396ZM16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888ZM5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924ZM10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285C15.1583 6.58254 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58254 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0ZM16.6634 0.705896C18.9198 0.705896 20.6918 2.84123 20.0883 5.21974C19.6809 6.82102 18.2062 7.88463 16.5631 7.8414C16.3984 7.8369 16.2363 7.82159 16.0796 7.79457C15.9659 7.77476 15.9086 7.64597 15.973 7.55051C16.5998 6.62288 16.9571 5.50703 16.9571 4.30922C16.9571 3.05918 16.5667 1.8938 15.8889 0.938252C15.8674 0.908532 15.8513 0.862601 15.8728 0.828378C15.8907 0.800459 15.9238 0.78605 15.9551 0.778845C16.1835 0.732013 16.4181 0.705896 16.6634 0.705896ZM5.33593 0.705806C5.58127 0.705806 5.81586 0.731923 6.04509 0.778755C6.07553 0.78596 6.10956 0.80127 6.12746 0.828288C6.14806 0.862511 6.13284 0.908442 6.11135 0.938162C5.43353 1.89371 5.04313 3.05909 5.04313 4.30913C5.04313 5.50694 5.4004 6.62279 6.02718 7.55042C6.09165 7.64588 6.03434 7.77467 5.92063 7.79448C5.76304 7.8224 5.60186 7.83681 5.43711 7.84131C3.79404 7.88454 2.31932 6.82093 1.91191 5.21965C1.30751 2.84114 3.07951 0.705806 5.33593 0.705806Z"
            fill="#3F8BBF"
          />
        </svg>
        <span className="text-pr fw-bold px-2">{data?.users}</span>
      </div>
      <div className="d-flex flex-wrap justify-content-center align-items-start px-md-2 text-sec fw-bold">
        {/* <span className="me-1">{data?.location?.slice(0, 50)} | </span> */}
        {data?.itinerary?.map((itin, i) => {
          return itin?.trim()?.length > 0 ? (
            <span key={i} className="me-1">
              {" "}
              {itin} {data?.itinerary?.length === i + 1 ? null : " | "}{" "}
            </span>
          ) : null;
        })}
      </div>
      <div className="w-100 px-3">
        <h6 className="text-pr fw-bold">Voyage description</h6>
        <p className="fw-light mb-1 px-2">
          {data?.residenceText?.slice(0, 120)}
        </p>
      </div>
      <div className="w-100">
        <h6 className="text-pr px-3 fw-bold">What’s included in this voyage</h6>
        <div className="row m-0 mt-1 px-3">
          {data?.amenities?.map((amen, ind) => (
            <div key={ind} className="col-md-4  col-6 all_offers_extra_cols">
              <div className="fw-bold d-flex mb-1">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                    fill="#92B9D5"
                  />
                </svg>
                <span className="alloffer-slider-card-extras-names">
                  {amen}
                </span>
              </div>
            </div>
          ))}
        </div>
        <h6 className="text-pr mt-2 px-3 fw-bold">
          Additional Features( upon request)
        </h6>
        <div className="row m-0 mt-2 px-3">
          {data?.extras?.map((extra, index) => (
            <div key={index} className="col-md-4  col-6 all_offers_extra_cols">
              <div className="fw-bold mb-1 d-flex">
                {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                </svg> */}
                <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
                  <path
                    d="M11 0C8.09351 0.035066 5.31595 1.20525 3.2606 3.2606C1.20525 5.31595 0.035066 8.09351 0 11C0.035066 13.9065 1.20525 16.6841 3.2606 18.7394C5.31595 20.7948 8.09351 21.9649 11 22C13.9065 21.9649 16.6841 20.7948 18.7394 18.7394C20.7948 16.6841 21.9649 13.9065 22 11C21.9649 8.09351 20.7948 5.31595 18.7394 3.2606C16.6841 1.20525 13.9065 0.035066 11 0ZM17.2857 11.7857H11.7857V17.2857H10.2143V11.7857H4.71429V10.2143H10.2143V4.71429H11.7857V10.2143H17.2857V11.7857Z"
                    fill="#3F8BBF"
                  />
                </svg>

                <span className="alloffer-slider-card-extras-names">
                  {extra}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {data?.admin ? (
        <>
          <div className="w-100 row justify-content-center align-items-end m-0 mt-3">
            {/* <div className="col-md-6 mt-md-2">
              <span className="text-sec price-type-btn mb-2 w-100">
                {data?.price} €
              </span>
              <button className="dark-btn book_now_btn w-100">Edit</button>
            </div> */}
            <div className="col-md-6 mt-2">
              <button
                onClick={() => data?.deleteBtn() || null}
                className="dark-btn delete-btn text-dark bg-gr book_now_btn w-100"
              >
                Delete
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* <div className="w-100 py-2 text-center">
                        {data?.onlyView ? null :
                            <a href={data?.viewMoreLink} target="_blank" rel="noopener noreferrer" className="text-decoration-underline fw-bold text-sec text-center mx-auto d-inline-block">View more</a>
                        }
                    </div> */}
          <div className="w-100 row justify-content-center align-items-center m-0">
           {data?.onlyView  && <div className="col-md-6 mt-md-2">
              <span className="text-pr price-type-btn">{data?.price} €</span>
            </div>}
            {data?.onlyView ? null : (
              <div className="col-md-6 mt-md-2">
                {/* {data?.bookNowLink ?
                                    <Link to={data?.bookNowLink} className="dark-btn book_now_btn text-white">Book Now</Link>
                                    :
                                    <button className="dark-btn book_now_btn">Book Now</button>
                                } */}
                {data?.onlyView ? 
                null 
                : (
                  <a
                    href={data?.viewMoreLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="dark-btn book_now_btn text-white"
                  >
                    View More
                  </a>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AllofferCard;
